export function HelpPage() {
  return (
    <section className="page-grid help-page">
      <div className="panel hero-panel">
        <p className="eyebrow">Named phenomenon, anti-slop edition</p>
        <h1>What this is measuring</h1>
        <p>
          Afterglow Atlas is not eye tracking. It is an attention proxy grounded in change blindness, inhibition of return, attentional capture, and information foraging.
        </p>
      </div>
      <div className="panel">
        <h2>The model</h2>
        <p>
          The app infers likely attention from pointer/touch dwell, visits, revisits, long presses, selection, and post-round recall. It gives you a heatmap of where your behavior says attention went — including what it probably skipped.
        </p>
      </div>
      <div className="panel">
        <h2>Why it’s useful</h2>
        <p>
          You get a small self-knowledge artifact: a profile, a heatmap, and a calibration gap between what you remember and where your hand lingered. Aggregates become a public commons: a map of collective salience and collective blind spots.
        </p>
      </div>
      <div className="panel">
        <h2>Privacy boundary</h2>
        <p>
          No camera, no raw eye data, no names, no accounts. The Worker receives a derived device hash, a Turnstile attestation, aggregate cell metrics, and your voluntary post-round marks. Raw local history can be exported or erased from settings.
        </p>
      </div>
      <div className="panel">
        <h2>Cloudflare free-tier shape</h2>
        <p>
          Pages hosts the static PWA, a Worker verifies Turnstile and writes D1 summaries, and a SQLite-backed Durable Object coordinates each live room over WebSockets. There is no Vectorize, Queues, Browser Rendering, paid database, or external analytics dependency.
        </p>
      </div>
    </section>
  );
}
